<template>
  <div class="home">
    <h2>Project Exiting Information</h2>

    <v-snackbar
        top
        multi-line
        :color="snackbar.color"
        :timeout="8000"
        v-model="snackbar.visible"
    >
      {{this.snackbar.text}}
    </v-snackbar>

    <v-row class="mt-3" dense>
      <v-col cols="12" md="5">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Facility Name"
            type="input"
            v-model="evaluation.providerName"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="City"
            type="input"
            v-model="evaluation.city"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="County Name"
            type="input"
            v-model="evaluation.providerCounty"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="County ID"
            type="input"
            v-model="evaluation.providerCountyId"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Project Number"
            type="input"
            v-model="evaluation.evaluationNumber"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Provider Type"
            type="input"
            v-model="evaluation.providerType"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Survey Type ID"
            type="input"
            v-model="evaluation.surveyType"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Survey Type"
            type="input"
            v-model="evaluation.surveyTypeName"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Federal ID"
            type="input"
            v-model="evaluation.fedId"
        />
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="Email Address"
            type="input"
            v-model="evaluation.emailAddr"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="License Number"
            type="input"
            v-model="evaluation.licNbr"
        />
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
            rounded
            readonly
            class="text-black"
            label="License Name"
            type="input"
            v-model="evaluation.licName"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="isReadOnly()"
            :readonly="isReadOnly()"
            label="Fiscal Year"
            type="input"
            v-model="evaluation.fiscalYear"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
            v-model="evaluation.evaluationType"
            :items="evaluationTypes"
            label="Evaluation Type"
            clearable
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
            v-model="evaluation.evaluationSubType"
            :items="evaluationSubTypes"
            label="Evaluation Sub Type"
            clearable
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="isReadOnly()"
            :readonly="isReadOnly()"
            label="Date Entered"
            type="date"
            v-model="evaluation.startDate"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="isReadOnly()"
            :readonly="isReadOnly()"
            label="Date Exited"
            type="date"
            v-model="evaluation.endDate"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            label="Letter Sent Date"
            type="date"
            v-model="exitInfo.letterSentDt"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="isReadOnly()"
            :readonly="isReadOnly()"
            label="Suspension Start Date"
            type="date"
            v-model="exitInfo.suspensionStartDate"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="isReadOnly()"
            :readonly="isReadOnly()"
            label="Suspension End Date"
            type="date"
            v-model="exitInfo.suspensionEndDate"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="isReadOnly()"
            :readonly="isReadOnly()"
            label="Suspension Reversal Date"
            type="date"
            v-model="exitInfo.suspensionReversalDate"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="2">
        <v-checkbox
            label="Enforcement?"
            :disabled="isReadOnly()"
            v-model="exitInfo.enforcement"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-checkbox
            label="Licensing Action?"
            :disabled="isReadOnly()"
            v-model="exitInfo.licensingAction"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-checkbox
            label="Maltreatment?"
            :disabled="isReadOnly()"
            v-model="exitInfo.maltreatment"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-checkbox
            label="Aborted?"
            :disabled="isReadOnly()"
            v-model="exitInfo.aborted"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="2">
        <v-text-field
            :readonly="isReadOnly()"
            label="Resident Count"
            type="number"
            v-model="exitInfo.residentCount"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            :readonly="isReadOnly()"
            label="Correction Orders"
            type="number"
            v-model="exitInfo.correctionOrders"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-autocomplete
            :readonly="isReadOnly()"
            label="Scope and Level Code"
            v-model="exitInfo.scopeLevelCode"
            @input="scopeLevelChange()"
            :items="scopeCodes"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="!isReadOnly()"
            readonly
            label="Highest Scope"
            type="text"
            v-model="exitInfo.scope"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
            :rounded="!isReadOnly()"
            readonly
            label="Highest Level"
            type="text"
            v-model="exitInfo.level"
        />
      </v-col>
    </v-row>

    <v-row dense v-if="this.evaluation.revisitNumber != null">
      <v-col>
        <v-radio-group
            row
            style="font-size: 20px"
            label="Schedule a Follow-up?: "
            :readonly="isReadOnly()"
            v-model="followUp">
          <v-radio label="Yes" value="y"/>
          <v-radio label="No" value="n"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row dense class="mt-5">
      <v-col cols="12" md="3" class="mr-15">
        <v-checkbox
            label="License Granted"
            :disabled="isReadOnly()"
            v-model="exitInfo.licenseGranted"
        />
        <v-checkbox
            label="Request Informal Conference"
            :disabled="isReadOnly()"
            v-model="exitInfo.conferenceRequest"
        />
        <v-checkbox
            label="Performance Incentive Eligible"
            :disabled="isReadOnly()"
            v-model="exitInfo.incentiveEligible"
        />
        <v-checkbox
            label="Request Plan of Corrections"
            :disabled="isReadOnly()"
            v-model="exitInfo.planRequest"
        />
        <v-checkbox
            label="Settlement Agreement"
            :disabled="isReadOnly()"
            v-model="exitInfo.settlementAgreement"
        />
        <v-select
            v-model="exitInfo.disciplinary"
            :items="disciplinaryValues"
            label="HOP/MortSci Disciplinary"
            clearable
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-row class="pt-2">
            <v-col cols="12" md="3" class="checkbox-item">
              <v-checkbox
                  label="License Denied"
                  v-model="exitInfo.licenseDenied"
              />
            </v-col>
            <v-col cols="12" md="3" class="checkbox-item">
            <v-text-field
                v-if="exitInfo.licenseDenied"
                label="License Denied Reversal Date"
                type="date"
                v-model="exitInfo.licenseDeniedReversalDate"
            />
            </v-col>
        </v-row>
        <v-row class="pt-0">
            <v-col cols="12" md="3" class="checkbox-item">
              <v-checkbox
                  label="Immediate Fines"
                  v-model="exitInfo.immediateFines"
              />
            </v-col>
            <v-col cols="12" md="3" class="checkbox-item">
              <v-text-field
                  v-if="exitInfo.immediateFines"
                  label="Immediate Fines Reversal Date"
                  type="date"
                  v-model="exitInfo.immediateFinesReversalDate"
              />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" class="checkbox-item">
              <v-checkbox
                  label="Immediate Correction Orders"
                  :disabled="isReadOnly()"
                  v-model="exitInfo.immediateOrders"
              />
            </v-col>
            <v-col cols="12" md="3" class="checkbox-item">
              <v-text-field
                  v-if="exitInfo.immediateOrders"
                  label="Immediate Orders Reversal Date"
                  type="date"
                  v-model="exitInfo.immediateOrdersReversalDate"
              />
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="checkbox-item">
            <v-checkbox
                label="License Revocation"
                :disabled="isReadOnly()"
                v-model="exitInfo.licenseRevocation"
            />
          </v-col>
          <v-col cols="12" md="3" class="checkbox-item">
            <v-text-field
                v-if="exitInfo.licenseRevocation"
                label="License Revocation Reversal Date"
                type="date"
                v-model="exitInfo.licenseRevocationReversalDate"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="checkbox-item">
            <v-checkbox
                label="Renewal Refusal"
                :disabled="isReadOnly()"
                v-model="exitInfo.renewalRefusal"
            />
          </v-col>
          <v-col cols="12" md="3" class="checkbox-item">
            <v-text-field
                v-if="exitInfo.renewalRefusal"
                label="Renewal Refusal Reversal Date"
                type="date"
                v-model="exitInfo.renewalRefusalReversalDate"
            />
          </v-col>
        </v-row>
      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-textarea
          :readonly="isReadOnly()"
          outlined
          label="Comment"
          rows="2"
          v-model="exitInfo.comment"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          @click="save()"
          color="primary"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import {ScopeSeverity} from "@/shared/model/ScopeSeverity";
import {evalApi} from "@/plugins/axios";
import {EvaluationType} from "@/shared/model/EvaluationType";
import {EvaluationSubType} from "@/shared/model/EvaluationSubType";
import {Disciplinary} from "@/shared/model/Disciplinary";

export default {

  props: {
    evaluation: Object,
    exitInfo: Object
  },

  mounted () {
    window.scrollTo(0, 0)
  },

  data() {
    return {
      followUp: "",
      snackbar: {
        visible: false,
        color: "#2a602c",
        text: ""
      },
      scopeSeverityList: ScopeSeverity.data,
      evaluationTypes: EvaluationType.values,
      evaluationSubTypes: EvaluationSubType.values,
      disciplinaryValues: Disciplinary.hopMortSciValues
    }
  },

  computed: {
    scopeCodes() {
      return this.scopeSeverityList.map((item) => {
        return item.code
      })
    }
  },

  methods: {
    isReadOnly() {
      return false
      /*
      if (this.evaluation.endDate != null) {
        let now = new Date()
        let expDate = new Date(this.evaluation.endDate)
        expDate.setMonth(expDate.getMonth() + 2)
        return now > expDate
      }
      return false
       */
    },

    isEmpty(str) {
      return (!str || str.length === 0 );
    },

    resetUncheckedDates() {
      if (!this.exitInfo.licenseDenied) {
        this.exitInfo.licenseDeniedReversalDate = null
      }
      if (!this.exitInfo.immediateFines) {
        this.exitInfo.immediateFinesReversalDate = null
      }
      if (!this.exitInfo.immediateOrders) {
        this.exitInfo.immediateOrdersReversalDate = null
      }
      if (!this.exitInfo.licenseRevocation) {
        this.exitInfo.licenseRevocationReversalDate = null
      }
      if (!this.exitInfo.renewalRefusal) {
        this.exitInfo.renewalRefusalReversalDate = null
      }

    },

    scopeLevelChange() {
      this.exitInfo.scope = null
      this.exitInfo.level = null
      for(let i=0; i<this.scopeSeverityList.length; i++) {
        if (this.exitInfo.scopeLevelCode === this.scopeSeverityList[i].code) {
          this.exitInfo.scope = this.scopeSeverityList[i].scope
          this.exitInfo.level = this.scopeSeverityList[i].level
        }
      }
    },

    scheduleFollowUp(newEval, revisitNumber) {
      evalApi.get("/evaluations/eval-num-check/" + newEval.evaluationNumber)
          .then(res => {
            if(!res.data) {
              if(this.isEmpty(newEval.startDate) || this.isEmpty(newEval.endDate)) {
                this.snackbar.color = "warning"
                this.snackbar.text = "Evaluation and Exit information saved. \nEntered and Exited dates are required to schedule a Follow-up."
                this.snackbar.visible = true
                return
              }
              newEval.revisitNumber = revisitNumber
              newEval.status = "ACTIVE"
              newEval.jobName = "EvaluationsImport"
              //newEval.evaluationType = "Scheduled Inspection"

              //These fields should NOT be carried over to next PCR number
              newEval.jiraIssueKey = null
              newEval.aspenEvent = null
              newEval.scheduleEnd = null
              newEval.scheduleStart = null
              newEval.teamLead = null
              newEval.startDate = null
              newEval.endDate = null
              newEval.dueDate = null

              evalApi.post("/evaluations/save", newEval
              ).then(() => {
                this.snackbar.color = "#2a602c"
                this.snackbar.text += "\n" + newEval.evaluationNumber + " has been created."
                this.snackbar.visible = true
              }).catch(error => {
                this.snackbar.color = "#b60000"
                this.snackbar.text = "An error occurred creating the evaluation record: >>>> " + error
                this.snackbar.visible = true
              })
            } else {
              this.snackbar.color = "warning"
              this.snackbar.text += "\n" + newEval.evaluationNumber + " already exists."
              this.snackbar.visible =true
            }
      })
    },

    createRollingProjNum() {
      if(this.isEmpty(this.evaluation.endDate)) {
        this.snackbar.color = "warning"
        this.snackbar.text += "\n" + "Exited date is required to create next project number."
        this.snackbar.visible = true
        return
      }

      let newEval = JSON.parse(JSON.stringify(this.evaluation));
      newEval.status = "ACTIVE"
      newEval.evaluationType = "Scheduled Inspection"

      //These fields should NOT be carried over to next PCR number
      newEval.jiraIssueKey = null
      newEval.aspenEvent = null
      newEval.scheduleEnd = null
      newEval.scheduleStart = null
      newEval.teamLead = null
      newEval.startDate = null
      //end date will be used to generate new due date
      //newEval.endDate = null
      newEval.dueDate = null
      evalApi.post("project-codes/createNextEval",
          newEval
      ).then(res => {
        this.snackbar.color = "#2a602c"
        this.snackbar.text += "\n" + res.data + " has been created."
      }).catch (error => {
        if (error.response.status === 400) {
          this.snackbar.color = "warning"
          this.snackbar.text += "\n" + "Next project number has already been created."
        }
      }).finally(() => {
        this.snackbar.visible = true
      })
    },

    async saveExitInfo() {
      this.resetUncheckedDates()
      this.exitInfo.evaluationNumber = this.evaluation.evaluationNumber
      evalApi.post("/exit/save", this.exitInfo).then(() => {
        this.snackbar.text = "Evaluation and Exit information saved.";

        if(this.followUp === 'y') {
          //TODO: this should be its own function in the backend
          let newEval = JSON.parse(JSON.stringify(this.evaluation));

          //parse current revisit number if revisit number is appended. Example: SL12342026-1
          const pattern = /-\d+$/
          if (pattern.test(newEval.evaluationNumber)) {
            const index = newEval.evaluationNumber.lastIndexOf("-");
            let revisitNumber = parseInt(newEval.evaluationNumber.substring(index + 1)) + 1;
            newEval.evaluationNumber = newEval.evaluationNumber.substr(0,index+1) + revisitNumber;
            newEval.revisitNumber = revisitNumber
            this.scheduleFollowUp(newEval, revisitNumber);
          } else {
            //default revisit number to 0 if null
            if(newEval.revisitNumber == null) {
              newEval.revisitNumber = 0
              this.scheduleFollowUp(newEval, 0);
            }
          }
        }

        //excluding HL numbers
        if(this.evaluation.revisitNumber == 0 && (!this.evaluation.evaluationNumber.startsWith("HL"))) {
          this.createRollingProjNum();
        } else {
          this.snackbar.visible = true;
        }
      }).catch(error => {
        this.snackbar.color = "#b60000"
        this.snackbar.text = "An error occurred saving the evaluation record: >>>> " + error
        this.snackbar.visible = true
      })
    },

    save() {
      this.evaluation.jobName = "EvaluationsImport"
      evalApi.post("/evaluations/save", this.evaluation
      ).then(() => {
        this.snackbar.color = "#2a602c"
        this.snackbar.text = "Evaluation information saved.";
        this.saveExitInfo()
      }).catch(error => {
        this.snackbar.color = "#b60000"
        this.snackbar.text = "An error occurred updating the evaluation record: >>>> " + error
        this.snackbar.visible = true
      })
    }
  }
}
</script>

<style>

.v-input--radio-group legend.v-label {
  font-size: 18px;
  font-weight: bold;
}

.v-input__control {
  padding-top: 0px;
  padding-bottom: 0px;
}

.text-black input {
  color: black !important;
}

.checkbox-group {
  width:100%;
  display: flex;
  flex-wrap: wrap;
}

.checkbox-item {
  color:#006;
  flex: 1;
  min-width: 20rem;
  padding-bottom: 0;
  padding-top: 0;
}



</style>